import { render, staticRenderFns } from "./HomeCalculate.vue?vue&type=template&id=4efa45d0&scoped=true"
import script from "./HomeCalculate.vue?vue&type=script&lang=js"
export * from "./HomeCalculate.vue?vue&type=script&lang=js"
import style0 from "./HomeCalculate.vue?vue&type=style&index=0&id=4efa45d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efa45d0",
  null
  
)

/* custom blocks */
import block0 from "./HomeCalculate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports